<article class="">
  <button class="collapsable-header" type="button" (click)="collapsed = !collapsed">
    <span>{{ 'winkelwagen-overzicht-kortingscode-label' | fromDictionary }}</span>
    <app-icon class="icon-xxxs collapsable-field-toggle" [class.is--active]="collapsed" anchor="icon-chevron-down-xxs"></app-icon>
  </button>

  <main class="collapsable-field" [class.is--collapsed]="collapsed" [style.--collapsable-height]="collapsableHeight">
    <div #collapsable>
      <form class="form--fill" [formGroup]="discountForm" (ngSubmit)="UpdateDiscounts()">
        <mat-form-field
          appearance="fill"
          color="accent"
          class="mat-form-field--simple"
          [ngClass]="applicable ? 'mb-4' : 'mb-2'"
          [subscriptSizing]="'dynamic'"
          >
          <input matInput formControlName="code" [placeholder]="'kortingscode-placeholder' | fromDictionary" />

          @if (!discountLoading && !discount) {
            <button matSuffix type="submit" class="button button--secondary button-icon button--xs">
              <app-icon [anchor]="discountCodes.length ? 'icon-close-xxs' : 'icon-chevron-right'"></app-icon>
            </button>
          }
          @if (!discountLoading && discount) {
            <button
              matSuffix
              type="button"
              (click)="removeDiscount(discount)"
              class="button button--secondary button-icon button--xs"
              >
              <app-icon [anchor]="discountCodes.length ? 'icon-close-xxs' : 'icon-chevron-right'"></app-icon>
            </button>
          }
          @if (discountLoading) {
            <app-icon matSuffix class="anim--spinning icon-secondary" anchor="icon-loader"></app-icon>
          }
        </mat-form-field>
      </form>

      @if (!applicable) {
        <div class="pb-4">
          <span class="alert alert--danger align-items-center d-block">
            <div class="alert__content">
              {{ 'discount-not-applicable' | fromDictionary }}
            </div>
          </span>
        </div>
      }
    </div>
  </main>
</article>

<!--<div>
<span>{{ discount.code }} - used? {{ discount.applicable }}</span>
<button class="button button-icon button--xs button--secondary" (click)="removeDiscount(discount)">
  <app-icon anchor="icon-close-xxs"></app-icon>
</button>
</div>-->
<!--<ul>
<li *ngFor="let discount of discountCodes">
  <span>{{ discount.code }} - used? {{ discount.applicable }}</span>
  <button class="button button-icon button--xs button--secondary" (click)="removeDiscount(discount)">
    <app-icon anchor="icon-close-xxs"></app-icon>
  </button>
</li>
</ul>-->
